import { useCallback, useState } from 'react';
import { useMutation } from 'react-query';
import { useMyTranslations } from 'hooks/useMyTranslations';
import { useStore } from 'hooks/useRootStore';
import { Switch } from '../Switch/Switch';
import { polygonsStatusCellTranslations } from './translations';
import { IPolygonsStatusCellProps, PolygonsStatusCellTransFields } from './types';

export const PolygonsStatusCell = ({
  id,
  isPolygonsWithProducts,
  changeStatus,
  disabled = false,
}: IPolygonsStatusCellProps) => {
  const {
    alertStore: { showAlert },
  } = useStore();

  const { t } = useMyTranslations<PolygonsStatusCellTransFields>([polygonsStatusCellTranslations.name]);

  const [active, setActive] = useState(isPolygonsWithProducts);

  const { mutate, isLoading } = useMutation(changeStatus, {
    mutationKey: ['changePolygonsStatus', id],
    onMutate: () => {
      setActive((prev) => !prev);
    },
    onSuccess: () => {
      showAlert(t('changePolygonsStatusSuccess'), 'success');
    },
    onError: () => {
      setActive((prev) => !prev);
    },
  });

  const onChange = useCallback(() => {
    mutate({ id, isPolygonsWithProducts: !active });
  }, [id, active, mutate]);

  return <Switch isActive={active} onChange={onChange} disabled={isLoading || disabled} />;
};
